if (!customElements.get("burger-menu")) {
  class BurgerMenu extends HTMLElement {
    constructor() {
      super();

      this.header = document.querySelector(".header-wrapper");
      this.burgerMenu = this.querySelector(".burger-menu");
      this.openButton = this.querySelector(".burger-menu__toggle--open-btn");
      this.closeButtons = this.querySelectorAll(".burger-menu__toggle--close-btn");
      this.overlay = this.querySelector(".burger-menu__overlay");

      if (this.header) this.header.preventHide = false;

      this.setListeners();
      this.initSubmenus();
    }

    open(event) {
      event.preventDefault();
      if (this.header) this.header.preventHide = true;

      this.burgerMenu.classList.add("burger-menu--open");
      this.overlay.classList.add("burger-menu__overlay--active");
      document.body.classList.add("overflow-hidden-drawer");
    }

    close(event) {
      event.preventDefault();

      this.burgerMenu.classList.remove("burger-menu--open");
      this.overlay.classList.remove("burger-menu__overlay--active");
      document.body.classList.remove("overflow-hidden-drawer");

      if (this.header) this.header.preventHide = false;

      this.burgerMenu.classList.add("hiding");
      setTimeout(() => this.burgerMenu.classList.remove("hiding"), 700);
    }

    setListeners() {
      this.openButton?.addEventListener("click", (event) => this.open(event));
      this.closeButtons?.forEach((btn) =>
        btn.addEventListener("click", (event) => this.close(event))
      );
      this.overlay?.addEventListener("click", (event) => this.close(event));
      this.burgerMenu?.addEventListener("keyup", (event) => {
        if (event.code === "Escape") this.close(event);
      });
    }

    initSubmenus() {
      const drawers = this.querySelectorAll("menu-drawer");

      drawers.forEach((drawer) => {
        const details = drawer.querySelector("details");
        const summary = drawer.querySelector("summary");
        const submenu = drawer.querySelector(".burger-menu__submenu");
        const backButton = drawer.querySelector(".burger-menu__submenu-back");

        if (!details || !summary || !submenu) return;

        summary.addEventListener("click", (event) => {
          event.preventDefault();
        
          const isOpen = details.hasAttribute("open");
          const wrapper = this.burgerMenu?.querySelector(".burger-menu__wrapper");
          const hasImages = submenu.querySelector(".mega-menu__item");
          
          if (wrapper) {
            if (hasImages) {
              wrapper.classList.add("burger-menu__wrapper--wide");
            } else {
              wrapper.classList.remove("burger-menu__wrapper--wide");
            }
          }
        
          // Andere schließen
          this.querySelectorAll("menu-drawer details[open]").forEach((el) => {
            if (el !== details) {
              el.removeAttribute("open");
              el.classList.remove("menu-opening");
            }
          });
        
          // Toggle aktuelles
          if (isOpen) {
            details.removeAttribute("open");
            details.classList.remove("menu-opening");
          } else {
            // ⬇️ Wichtig: zuerst öffnen
            details.setAttribute("open", "");
            // ⬇️ Dann Klasse setzen – das triggert die Animation
            setTimeout(() => {
              details.classList.add("menu-opening");
            }, 10); // kleiner Delay für CSS transition
            submenu.focus();
          }
        });
              
              backButton?.addEventListener("click", (event) => {
  event.preventDefault();

  const wrapper = document.querySelector(".burger-menu__wrapper"); // 🔧 Das hat gefehlt
  if (wrapper) {
    wrapper.classList.remove("burger-menu__wrapper--wide");
  }

  // Für sanftes Zurücksliden
  submenu.style.transform = "translateX(100%)";
  submenu.style.transition = "transform 300ms ease";

  // Nach der Animation -> wirklich schließen
  setTimeout(() => {
    details.removeAttribute("open");
    details.classList.remove("menu-opening");
    submenu.style.transition = "";
    submenu.style.transform = "";
  }, 300);
});
      });
    }
  }

  customElements.define("burger-menu", BurgerMenu);
}